import { render, staticRenderFns } from "./VoteResult.vue?vue&type=template&id=09f21a39&scoped=true&"
import script from "./VoteResult.vue?vue&type=script&lang=js&"
export * from "./VoteResult.vue?vue&type=script&lang=js&"
import style0 from "./VoteResult.vue?vue&type=style&index=0&id=09f21a39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f21a39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
